import { useNavigate } from "react-router-dom";
import Cards from "../components/Cards";
import Card from "../components/Card";

export default function PageSettingsWidget() {
    
    const navigate = useNavigate();

    return (
        <div className="page page-settings-widget">
            <p>
                For widget installs, you can book a free implementation meeting with our team <a rel="noreferrer" href="https://calendly.com/georgehampton/urgent-couriers-shopify-implementation" target="_blank"><b>here</b></a>.
            </p>
            <Cards>
                <Card title="Delivery" description="Update widget delivery settings" onClick={() => navigate(`Delivery${window.location.search}`)} />
                <Card title="Pickup" description="Update widget pickup settings" onClick={() => navigate(`Pickup${window.location.search}`)} />
            </Cards>
        </div>
    );
}